// import React, { useEffect, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   FaLaptopCode,
//   FaRocket,
//   FaBriefcase,
//   FaShoppingCart,
// } from "react-icons/fa";
// import img1 from "./Logo/my-logo.png"; // <-- Infronex logo

// export default function WelcomeModal({ onClose, onMore }) {
//   const [show, setShow] = useState(true);

//   useEffect(() => {
//     AOS.init({ duration: 600, once: true });
//   }, []);

//   const handleClose = () => {
//     setShow(false);
//     if (onClose) onClose();
//   };

//   const handleMore = () => {
//     if (onMore) return onMore();
//     window.location.href = "/services";
//   };

//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
//       <div
//         data-aos="zoom-in"
//         className="bg-white w-[95%] sm:w-[420px] rounded-2xl shadow-2xl overflow-hidden relative"
//       >
//         {/* Header */}
//         <div className="flex justify-between items-center bg-gradient-to-r from-sky-600 to-indigo-700 px-4 py-2.5">
//           <div className="flex items-center gap-2">
//             <FaLaptopCode className="text-white w-5 h-5" />
//             <div>
//               <h2 className="text-white text-base font-semibold">
//                 CSG Institution
//               </h2>
//               <p className="text-sky-100 text-xs">In tie-up with Infronex</p>
//             </div>
//           </div>
//           <button
//             onClick={handleClose}
//             aria-label="Close welcome modal"
//             className="text-white text-xl leading-none font-bold"
//           >
//             ×
//           </button>
//         </div>

//         {/* Body */}
//         <div className="px-5 py-4">
//           <p
//             className="text-gray-800 mb-3 text-sm text-center"
//             data-aos="fade-up"
//           >
//             Welcome to <strong>CSG Institution</strong> — partnered with{" "}
//             <strong>Infronex IT Products & Services</strong> to provide
//             practical training and IT solutions.
//           </p>

//           {/* Infronex Logo */}
//           <div
//             className="flex justify-center mb-4"
//             data-aos="fade-up"
//             data-aos-delay="100"
//           >
//             <img
//               src={img1}
//               alt="Infronex Logo"
//               className="w-24 sm:w-28 object-contain rounded-full"
//             />
//           </div>

//           {/* Simple Service Boxes */}
//           <div
//             className="grid grid-cols-1 gap-3"
//             data-aos="fade-up"
//             data-aos-delay="200"
//           >
//             <div className="flex items-center gap-3 p-3 border rounded-lg shadow-sm">
//               <FaRocket className="text-blue-600 w-4 h-4" />
//               <h3 className="text-gray-900 text-sm font-semibold">
//                 Software Service
//               </h3>
//             </div>

//             <div className="flex items-center gap-3 p-3 border rounded-lg shadow-sm">
//               <FaBriefcase className="text-green-600 w-4 h-4" />
//               <h3 className="text-gray-900 text-sm font-semibold">
//                 Hardware Service
//               </h3>
//             </div>
//           </div>

//           <p
//             className="mt-3 text-gray-700 text-xs text-center"
//             data-aos="fade-up"
//             data-aos-delay="300"
//           >
//             Together, CSG & Infronex deliver training + services for modern IT &
//             hardware needs.
//           </p>
//         </div>

//         {/* Footer */}
//         <div className="bg-gray-50 px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-3">
//           <button
//             onClick={handleMore}
//             className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm rounded-full inline-flex items-center gap-2 transition"
//           >
//             Learn More <FaShoppingCart className="w-4 h-4" />
//           </button>
//           <button
//             onClick={handleClose}
//             className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-800 px-4 py-2 text-sm rounded-full transition"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useEffect, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   FaLaptopCode,
//   FaRocket,
//   FaBriefcase,
//   FaShoppingCart,
// } from "react-icons/fa";
// import img1 from "./Logo/my-logo.png"; // Infronex logo

// export default function WelcomeModal({ onClose, onMore }) {
//   const [show, setShow] = useState(true);

//   useEffect(() => {
//     AOS.init({ duration: 600, once: true });
//   }, []);

//   const handleClose = () => {
//     setShow(false);
//     if (onClose) onClose();
//   };

//   const handleMore = () => {
//     if (onMore) return onMore();
//     window.location.href = "/services";
//   };

//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
//       <div
//         data-aos="zoom-in"
//         className="bg-white w-[95%] sm:w-[420px] rounded-2xl shadow-2xl overflow-hidden relative max-h-[90vh] flex flex-col"
//       >
//         {/* Header */}
//         <div className="flex justify-between items-center bg-gradient-to-r from-sky-600 to-indigo-700 px-4 py-2.5 flex-shrink-0">
//           <div className="flex items-center gap-2">
//             <FaLaptopCode className="text-white w-5 h-5" />
//             <div>
//               <h2 className="text-white text-base font-semibold">
//                 CSG Institution
//               </h2>
//               <p className="text-sky-100 text-xs">In tie-up with Infronex</p>
//             </div>
//           </div>
//           <button
//             onClick={handleClose}
//             aria-label="Close welcome modal"
//             className="text-white text-xl leading-none font-bold"
//           >
//             ×
//           </button>
//         </div>

//         {/* Scrollable Body */}
//         <div className="px-5 py-4 overflow-y-auto flex-grow">
//           <p
//             className="text-gray-800 mb-3 text-sm text-center"
//             data-aos="fade-up"
//           >
//             Welcome to <strong>CSG Institution</strong> — partnered with{" "}
//             <strong>Infronex IT Products & Services</strong> to provide
//             practical training and IT solutions.
//           </p>

//           {/* Infronex Logo */}
//           <div
//             className="flex justify-center mb-4"
//             data-aos="fade-up"
//             data-aos-delay="100"
//           >
//             {/* <img
//               src={img1}
//               alt="Infronex Logo"
//               className="w-20 sm:w-24 object-contain rounded-full"
//             /> */}
//             <img
//               src={img1}
//               alt="Infronex Logo"
//               className="w-36 sm:w-40 object-contain rounded-full drop-shadow-md  animate-pulse"
//             />
//           </div>

//           {/* Simple Service Boxes */}
//           <div
//             className="grid grid-cols-1 gap-3"
//             data-aos="fade-up"
//             data-aos-delay="200"
//           >
//             <div className="flex items-center gap-3 p-3 border rounded-lg shadow-sm">
//               <FaRocket className="text-blue-600 w-4 h-4" />
//               <h3 className="text-gray-900 text-sm font-semibold">
//                 Software Service
//               </h3>
//             </div>

//             <div className="flex items-center gap-3 p-3 border rounded-lg shadow-sm">
//               <FaBriefcase className="text-green-600 w-4 h-4" />
//               <h3 className="text-gray-900 text-sm font-semibold">
//                 Hardware Service
//               </h3>
//             </div>
//           </div>

//           <p
//             className="mt-3 text-gray-700 text-xs text-center"
//             data-aos="fade-up"
//             data-aos-delay="300"
//           >
//             Together, CSG & Infronex deliver training + services for modern IT &
//             hardware needs.
//           </p>
//         </div>

//         {/* Footer */}
//         <div className="bg-gray-50 px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 flex-shrink-0">
//           <button
//             onClick={handleMore}
//             className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm rounded-full inline-flex items-center gap-2 transition"
//           >
//             Learn More <FaShoppingCart className="w-4 h-4" />
//           </button>
//           <button
//             onClick={handleClose}
//             className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-800 px-4 py-2 text-sm rounded-full transition"
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaLaptopCode,
  FaRocket,
  FaBriefcase,
  FaShoppingCart,
} from "react-icons/fa";
import img1 from "./Logo/my-logo.png"; // Infronex logo
import { Link } from "react-router-dom";

export default function WelcomeModal({ onClose, onMore }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 600, once: true });
  }, []);

  const handleClose = () => {
    setShow(false);
    if (onClose) onClose();
  };

  // const handleMore = () => {
  //   if (onMore) return onMore();
  //   window.location.href = "/services";
  // };

  // if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
      <div
        data-aos="zoom-in"
        className="bg-white w-[95%] sm:w-[480px] md:w-[520px] rounded-2xl shadow-2xl overflow-hidden relative max-h-[90vh] flex flex-col"
      >
        {/* Header */}
        <div className="flex justify-between items-center bg-gradient-to-r from-sky-600 to-indigo-700 px-4 py-2.5 flex-shrink-0">
          <div className="flex items-center gap-2">
            <FaLaptopCode className="text-white w-5 h-5" />
            <div>
              <h2 className="text-white text-base font-semibold">
                CSG Institution
              </h2>
              <p className="text-sky-100 text-xs">In tie-up with Infronex</p>
            </div>
          </div>
          <button
            onClick={handleClose}
            aria-label="Close welcome modal"
            className="text-white text-xl leading-none font-bold"
          >
            ×
          </button>
        </div>

        {/* Scrollable Body */}
        <div
          className="px-5 py-4 overflow-y-auto flex-grow"
          style={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <style>
            {`
              /* Hide scrollbar for Chrome, Safari, Edge */
              div::-webkit-scrollbar {
                display: none;
              }
            `}
          </style>

          <p
            className="text-gray-800 mb-3 text-sm text-center"
            data-aos="fade-up"
          >
            Welcome to <strong>CSG Institution</strong> — partnered with{" "}
            <strong>Infronex IT Products & Services</strong> to provide
            practical training and IT solutions.
          </p>

          {/* Infronex Logo */}
          <div
            className="flex justify-center mb-4"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <img
              src={img1}
              alt="Infronex Logo"
              className="w-36 sm:w-40 object-contain rounded-full drop-shadow-md animate-pulse"
            />
          </div>

          {/* Simple Service Boxes */}
          <div
            className="grid grid-cols-1 gap-3"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="flex items-center gap-3 p-3 border rounded-lg shadow-sm">
              <FaRocket className="text-blue-600 w-4 h-4" />
              <h3 className="text-gray-900 text-sm font-semibold">
                Software Service
              </h3>
            </div>

            <div className="flex items-center gap-3 p-3 border rounded-lg shadow-sm">
              <FaBriefcase className="text-green-600 w-4 h-4" />
              <h3 className="text-gray-900 text-sm font-semibold">
                Hardware Service
              </h3>
            </div>
          </div>

          <p
            className="mt-3 text-gray-700 text-xs text-center"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Together, CSG & Infronex deliver training + services for modern IT &
            hardware needs.
          </p>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 flex-shrink-0">
          <Link
            onClick={handleClose}
            to="/infronex"
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 text-sm rounded-full inline-flex items-center gap-2 transition"
          >
            Learn More <FaShoppingCart className="w-4 h-4" />
          </Link>
          <button
            onClick={handleClose}
            className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-800 px-4 py-2 text-sm rounded-full transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
